import { render, staticRenderFns } from "./BookModal.vue?vue&type=template&id=3b0b08a8&scoped=true&"
import script from "./BookModal.vue?vue&type=script&lang=js&"
export * from "./BookModal.vue?vue&type=script&lang=js&"
import style0 from "./BookModal.vue?vue&type=style&index=0&id=3b0b08a8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0b08a8",
  null
  
)

export default component.exports